import {ReportLog} from "../../../model/ReportLog";

export class ImportedContactsDialog {

    static instanceFactory = (params: {
        log: ReportLog,
        controller: any,
        template: any
    }) => ({
        controller: [
            '$mdDialog',
            params.controller
        ],
        template: params.template,
        locals: {
            log: params.log
        },
        bindings: {
            log: '<'
        },
        bindToController: true,
        controllerAs: '$ctrl',
        clickOutsideToClose: true
    });

    constructor(protected $mdDialog: angular.material.IDialogService) {
    }

    protected log: ReportLog;

    protected closeDialog = this.$mdDialog.hide;

}